(() => {
  "use strict";
  /* 
    Note: some of the customCut and contact info below isn't used
    Instead it is grabbed off the page from the help section that's already there
  */
  const CONFIG = {
    apiBase: null,
    brand: null,
    debounceMs: 180,
    minQueryLength: 1,
    limit: 8,
    inputSelector: null,
    wrapperSelector: null,
    noResultsText: "No frames found",
    noMatchHeading: "We can't find that frame, but we can still help!",
    customCut: {
      title: "Custom Cut",
      body: [
        "Can't find replacement lenses that match your sunglasses?",
        "We make custom lenses. Just send us your sunglasses and we'll cut your lenses, install them and ship them back.",
      ],
      linkText: "Custom Cut Lenses",
      linkUrl: "/products/custom-cut-replacement-lenses",
    },
    contact: {
      title: "Contact Our Team",
      body: ["Our eyewear experts are available weekdays from 9am-5pm PST"],
      linkText: "Contact Our Team",
      linkUrl: "/pages/contact-us",
    },
  };

  const USER_CONFIG =
    window.FrameFinderSearchConfig &&
    typeof window.FrameFinderSearchConfig === "object"
      ? window.FrameFinderSearchConfig
      : {};

  const settings = { ...CONFIG, ...USER_CONFIG };
  const instances = new WeakMap();

  function getApiBase() {
    if (typeof settings.apiBase === "string" && settings.apiBase.trim()) {
      return settings.apiBase.trim().replace(/\/$/, "");
    }

    const hostname = window.location.hostname;
    const fullUrl = window.location.href;
    const isProduction =
      hostname === "www.revantoptics.com" ||
      hostname === "revantoptics.com" ||
      fullUrl.includes("/store/revantoptics") ||
      fullUrl.includes("revantoptics.myshopify.com");

    return isProduction
      ? "https://enhanced-search-prod-lmkyt.ondigitalocean.app"
      : "https://revant-enhanced-search-fl5m2.ondigitalocean.app";
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function collectStringValues(value) {
    if (typeof value === "string") {
      const trimmed = value.trim();
      return trimmed ? [trimmed] : [];
    }
    if (typeof value === "number") return [String(value)];
    if (Array.isArray(value)) {
      return value.flatMap((item) => collectStringValues(item));
    }
    return [];
  }

  function normalizeCode(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function findMatchedModelNumber(product, query) {
    const candidates = [
      ...collectStringValues(product && product.frame_sku),
      ...collectStringValues(product && product.legacy_oem_frame_skus),
    ];

    if (!candidates.length) return "";

    const normalizedQuery = normalizeCode(query);
    if (!normalizedQuery) return candidates[0];

    const exactMatch = candidates.find(
      (code) => normalizeCode(code) === normalizedQuery
    );
    if (exactMatch) return exactMatch;

    const partialMatch = candidates.find((code) => {
      const normalizedCode = normalizeCode(code);
      return (
        normalizedCode.includes(normalizedQuery) ||
        normalizedQuery.includes(normalizedCode)
      );
    });

    return partialMatch || candidates[0];
  }

  const RARE_MODE_TEXT_REGEX = /rare\s+shades|frame\s+number\s+(?:may\s+)?look/i;
  const STANDARD_MODE_TEXT_REGEX = /search\s+by\s+frame\s+name/i;

  function detectMode(wrapper, input) {
    if (typeof settings.mode === "string" && settings.mode.trim()) {
      return settings.mode.trim().toLowerCase();
    }

    const explicitMode =
      input?.dataset?.frameFinderMode ||
      wrapper?.dataset?.frameFinderMode ||
      wrapper
        ?.closest("[data-frame-finder-mode]")
        ?.getAttribute("data-frame-finder-mode");
    if (explicitMode) return explicitMode.trim().toLowerCase();

    let current = wrapper;
    for (let depth = 0; depth < 6 && current; depth += 1) {
      const text = (current.textContent || "").replace(/\s+/g, " ");
      const hasRare = RARE_MODE_TEXT_REGEX.test(text);
      const hasStandard = STANDARD_MODE_TEXT_REGEX.test(text);

      if (hasRare && !hasStandard) return "rare";
      if (hasStandard && !hasRare) return "standard";

      current = current.parentElement;
    }

    return "standard";
  }

  function isVisible(element) {
    if (!element) return false;
    if (element.hidden) return false;
    if (element.offsetParent) return true;
    return element.getClientRects().length > 0;
  }

  function isAbortError(error) {
    if (!error) return false;
    if (error.name === "AbortError") return true;
    if (error.code === 20) return true;
    return false;
  }

  function injectStyles() {
    if (document.getElementById("frame-finder-search-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "frame-finder-search-styles";
    style.textContent = `
      .ff-search-results[hidden] {
        display: none !important;
      }

      .ff-search-results[data-state="open"] {
        display: block;
      }

      .ff-search-results__list {
        list-style: none;
        margin: 0;
        padding: 0;
      }

      .ff-search-results__item + .ff-search-results__item {
        border-top: 1px solid rgba(18, 18, 18, 0.12);
      }

      .ff-search-results__button {
        appearance: none;
        background: transparent;
        border: 0;
        color: inherit;
        cursor: pointer;
        display: block;
        font: inherit;
        padding: 1.25rem 1.75rem;
        text-align: left;
        width: 100%;
      }

      .ff-search-results__button:hover,
      .ff-search-results__button[aria-selected="true"] {
        background: rgba(18, 18, 18, 0.05);
      }

      .ff-search-results__empty,
      .ff-search-results__status {
        padding: 1.25rem 1.75rem;
      }

      .ff-search-results__loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 2rem 1.75rem;
        min-height: 8rem;
      }

      .ff-search-results__spinner {
        width: 2.4rem;
        height: 2.4rem;
        border: 0.2rem solid rgba(18, 18, 18, 0.12);
        border-top-color: rgba(18, 18, 18, 0.75);
        border-radius: 50%;
        animation: ff-frame-finder-search-spin 0.75s linear infinite;
      }

      @keyframes ff-frame-finder-search-spin {
        to {
          transform: rotate(360deg);
        }
      }

      .ff-search-results mark {
        background: rgba(255, 235, 59, 0.55);
        color: inherit;
      }

      .ff-search-results__title {
        display: block;
        font-weight: 500;
      }

      .ff-search-results__model {
        color: rgba(18, 18, 18, 0.6);
        display: block;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }

      .ff-search-results__no-match {
        display: flex;
        flex-direction: column;
        gap: 1.75rem;
        padding: 1.5rem 1.75rem;
      }

      .ff-search-results__no-match-heading {
        font-weight: 700;
        margin: 0;
      }
    `;

    document.head.appendChild(style);
  }

  function getSearchScope(wrapper) {
    if (!wrapper) return document.body;

    let current = wrapper;
    while (current && current !== document.body) {
      const classAndIdText = [
        current.id,
        typeof current.className === "string" ? current.className : "",
        current.getAttribute ? current.getAttribute("data-frame-finder-root") : "",
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      const text = (current.textContent || "").replace(/\s+/g, " ").trim();

      if (
        /frame[-_\s]?finder/.test(classAndIdText) ||
        /search by frame name or frame number/i.test(text) ||
        /\ball\s+.+?\s+frames\b/i.test(text)
      ) {
        return current;
      }

      current = current.parentElement;
    }

    return wrapper.closest("section, main, article") || wrapper;
  }

  function getTextScore(wrapper) {
    const input = wrapper.querySelector('.search__input[type="search"], input.search__input');
    if (!input) return -1000;

    const scope = getSearchScope(wrapper);
    const text = (scope ? scope.textContent : wrapper.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    const classAndIdText = [
      wrapper.className,
      wrapper.id,
      wrapper.closest("[id]")?.id,
      wrapper.closest("[class]")?.className,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    let score = 0;

    if (/frame[-_\s]?finder/.test(classAndIdText)) score += 80;
    if (/search by frame name or frame number/i.test(text)) score += 60;
    if (/\ball\s+.+?\s+frames\b/i.test(text)) score += 40;
    if (/brand/i.test(text)) score += 10;
    if (/header|drawer|site-nav|navigation/i.test(classAndIdText)) score -= 60;

    return score;
  }

  function resolveWrapperForInput(input) {
    return (
      input.closest(
        "[data-frame-finder-search], .search__form-wrap, .frame-search-wrap, [data-frame-finder-root]"
      ) ||
      (input.closest("form") && input.closest("form").parentElement) ||
      input.closest("form") ||
      input.parentElement
    );
  }

  function getCandidateWrappers() {
    if (settings.wrapperSelector) {
      return Array.from(document.querySelectorAll(settings.wrapperSelector));
    }

    const explicitWrappers = Array.from(
      document.querySelectorAll("[data-frame-finder-search]")
    );
    if (explicitWrappers.length > 0) {
      return explicitWrappers;
    }

    const inputSelector =
      settings.inputSelector ||
      '.search__input[type="search"], input.search__input[type="search"]';
    const inputs = Array.from(document.querySelectorAll(inputSelector));
    const candidateWrappers = new Set();

    inputs.forEach((input) => {
      const wrapper = resolveWrapperForInput(input);
      if (wrapper) candidateWrappers.add(wrapper);
    });

    const wrappers = Array.from(candidateWrappers);
    const scored = wrappers
      .map((wrapper) => ({ wrapper, score: getTextScore(wrapper) }))
      .filter((entry) => entry.score > 0);

    if (scored.length > 0) {
      return scored.map((entry) => entry.wrapper);
    }

    if (wrappers.length === 1) {
      return wrappers;
    }

    return [];
  }

  const PLACEHOLDER_BRAND_REGEX =
    /\b(isn.t|not|no)\s+(listed|available|found)\b|^any\s+brand$/i;

  function isPlaceholderBrand(value) {
    return PLACEHOLDER_BRAND_REGEX.test(value);
  }

  function extractBrandFromText(text) {
    if (!text) return "";
    const match = text.match(/\ball\s+(.+?)\s+frames\b/i);
    return match ? match[1].trim() : "";
  }

  function resolveBrand(wrapper, input) {
    if (typeof settings.getBrand === "function") {
      const configuredBrand = settings.getBrand({ wrapper, input });
      if (configuredBrand) return String(configuredBrand).trim();
    }

    if (typeof settings.brand === "string" && settings.brand.trim()) {
      return settings.brand.trim();
    }

    const drawer = wrapper?.closest("frame-finder-drawer");
    if (drawer) {
      const nextBtn = drawer.querySelector(".ff-button-next");
      const drawerBrand = nextBtn?.getAttribute("data-selected_brand");
      if (drawerBrand && drawerBrand.trim()) return drawerBrand.trim();
    }

    const datasetBrand =
      input?.dataset?.frameFinderBrand ||
      wrapper?.dataset?.frameFinderBrand ||
      wrapper?.closest("[data-frame-finder-brand]")?.getAttribute("data-frame-finder-brand");

    if (datasetBrand) {
      return datasetBrand.trim();
    }

    const scopedBrandField = getSearchScope(wrapper);
    if (scopedBrandField) {
      const brandField = scopedBrandField.querySelector(
        'input[name*="brand"]:checked, select[name*="brand"], [data-selected-brand]'
      );

      if (brandField) {
        const fieldValue =
          brandField.value ||
          brandField.getAttribute("data-selected-brand") ||
          brandField.textContent;

        if (fieldValue && String(fieldValue).trim()) {
          return String(fieldValue).trim();
        }
      }

      const headingNodes = scopedBrandField.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5"
      );

      for (const headingNode of headingNodes) {
        const headingBrand = extractBrandFromText(headingNode.textContent);
        if (headingBrand) return headingBrand;
      }
    }

    return "";
  }

  function highlightText(text, query, minLength) {
    const safeText = escapeHtml(text);
    if (!query) return safeText;

    const effectiveMinLength = typeof minLength === "number" ? minLength : 3;
    const words = query
      .trim()
      .split(/\s+/)
      .map((word) => word.trim())
      .filter((word) => word.length >= effectiveMinLength);

    if (words.length === 0) return safeText;

    let highlighted = safeText;
    words.forEach((word) => {
      const regex = new RegExp(`(${escapeRegExp(escapeHtml(word))})`, "gi");
      highlighted = highlighted.replace(regex, "<mark>$1</mark>");
    });

    return highlighted;
  }

  const RIGHT_ARROW_SVG =
    '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-arrow-right">' +
    '<path d="M10.476 6.16658L6.00601 1.69657L7.18451 0.518066L13.6663 6.99992L7.18451 13.4817L6.00601 12.3032L10.476 7.83325H0.333008V6.16658H10.476Z" fill="currentColor"/>' +
    "</svg>";

  
  function renderHelpCard(modifier, data) {
    if (!data) return "";
    const bodyParts = Array.isArray(data.body) ? data.body : [data.body];
    const bodyHtml = bodyParts
      .filter((part) => typeof part === "string" && part.trim())
      .map((part) => `<p>${escapeHtml(part)}</p>`)
      .join("");
    const safeUrl = escapeHtml(data.linkUrl || "#");
    const safeLinkText = escapeHtml(data.linkText || "");
    const safeTitle = escapeHtml(data.title || "");

    return `
      <div class="help-option help-option-${modifier}">
        <h4>${safeTitle}</h4>
        <div class="help-option-text">${bodyHtml}</div>
        <a href="${safeUrl}" class="link">
          <span class="help-link-text">${safeLinkText}</span>
          <span class="icon-wrapper">${RIGHT_ARROW_SVG}</span>
        </a>
      </div>
    `;
  }

  function renderNoMatchEmptyState() {
    const drawer = document.querySelector('frame-finder-drawer');
    const quiz_help = drawer?.querySelector('.quiz-help');
    const help_options = quiz_help?.querySelector('.help-options-wrap');

    if (quiz_help && help_options) {
      const heading = quiz_help.dataset.no_match_heading || settings.noMatchHeading;
      return `
        <div class="ff-search-results__no-match" role="status">
          <p class="ff-search-results__no-match-heading">${escapeHtml(heading)}</p>
          ${help_options.outerHTML}
        </div>
      `;
    }

    // fallback to hardcoded content
    return `
      <div class="ff-search-results__no-match" role="status">
        <p class="ff-search-results__no-match-heading">${escapeHtml(settings.noMatchHeading)}</p>
        <div class="help-options-wrap">
          ${renderHelpCard("custom", settings.customCut)}
          ${renderHelpCard("contact", settings.contact)}
        </div>
      </div>
    `;
  }

  function dispatchFrameFinderEvent(target, name, detail) {
    target.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail,
      })
    );
  }

  class FrameFinderSearch {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.host = wrapper;
      this.drawer = wrapper.closest("frame-finder-drawer");
      this.input = this.host.querySelector('.search__input[type="search"], input.search__input');
      this.form = this.input ? this.input.form : null;
      this.resetButton = this.host.querySelector(".reset__button");
      this.statusElement = this.host.querySelector(".predictive-search-status");
      this.resultsContainer = this.getResultsContainer();
      this.apiBase = getApiBase();
      this.cache = new Map();
      this.abortController = null;
      this.searchRequestId = 0;
      this.debounceTimer = null;
      this.activeIndex = -1;
      this.products = [];
      this.selectedProduct = null;
      this.lastQuery = "";
      this.mode = detectMode(wrapper, this.input);
      this.lastObservedBrand = "";
      this.brandObserver = null;

      if (!this.input || !this.form || !this.resultsContainer) {
        return;
      }

      this.bindEvents();
      this.bindBrandChangeWatcher();
      this.renderIdleState();
    }

    getDrawerBrand() {
      const nextBtn = this.drawer && this.drawer.querySelector(".ff-button-next");
      return (nextBtn && nextBtn.getAttribute("data-selected_brand")) || "";
    }

    bindBrandChangeWatcher() {
      if (!this.drawer || typeof MutationObserver === "undefined") return;

      this.lastObservedBrand = this.getDrawerBrand();

      this.brandObserver = new MutationObserver(() => {
        const currentBrand = this.getDrawerBrand();
        if (currentBrand === this.lastObservedBrand) return;
        this.lastObservedBrand = currentBrand;
        this.resetSearchState();
      });

      this.brandObserver.observe(this.drawer, {
        attributes: true,
        attributeFilter: ["data-selected_brand"],
        subtree: true,
      });
    }

    resetSearchState() {
      this.input.value = "";
      this.products = [];
      this.activeIndex = -1;
      this.selectedProduct = null;
      this.lastQuery = "";
      delete this.input.dataset.selectedProductId;
      delete this.input.dataset.selectedProductHandle;
      delete this.input.dataset.selectedModelNumber;
      if (this.resetButton) {
        this.resetButton.classList.add("hidden");
      }
      this.cache.clear();
      this.renderIdleState();
      this.closeResults();
    }

    getResultsContainer() {
      let container = this.host.querySelector("[data-predictive-search]");

      if (!container) {
        container = document.createElement("div");
        container.className = "predictive-search predictive-search--header";
        container.setAttribute("data-predictive-search", "");
        container.setAttribute("tabindex", "-1");
        this.host.appendChild(container);
      }

      container.classList.add("ff-search-results");
      container.hidden = true;
      container.setAttribute("role", "listbox");
      container.setAttribute("aria-label", "Frame finder results");

      return container;
    }

    bindEvents() {
      this.onInput = this.onInput.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onReset = this.onReset.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.input.setAttribute("autocomplete", "off");
      this.input.setAttribute("aria-expanded", "false");

      this.input.addEventListener("input", this.onInput);
      this.input.addEventListener("focus", this.onFocus);
      this.input.addEventListener("keydown", this.onKeydown);
      this.form.addEventListener("submit", this.onSubmit);

      if (this.resetButton) {
        this.resetButton.addEventListener("click", this.onReset);
      }

      this.resultsContainer.addEventListener("click", (event) => {
        const button = event.target.closest("[data-frame-finder-index]");
        if (!button) return;

        const index = Number(button.getAttribute("data-frame-finder-index"));
        if (Number.isNaN(index) || !this.products[index]) return;
        this.selectProduct(index);
      });

      document.addEventListener("click", this.onDocumentClick);
    }

    onInput() {
      this.selectedProduct = null;
      delete this.input.dataset.selectedProductId;
      delete this.input.dataset.selectedProductHandle;

      const query = this.input.value.trim();

      if (this.resetButton) {
        this.resetButton.classList.toggle("hidden", !query);
      }

      if (query.length < settings.minQueryLength) {
        this.products = [];
        this.activeIndex = -1;
        this.closeResults();
        return;
      }

      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(() => {
        this.search(query);
      }, settings.debounceMs);
    }

    onFocus() {
      if (this.products.length > 0) {
        this.openResults();
      }
    }

    onKeydown(event) {
      if (!this.isOpen() || this.products.length === 0) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        this.setActiveIndex(
          this.activeIndex < this.products.length - 1 ? this.activeIndex + 1 : 0
        );
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        this.setActiveIndex(
          this.activeIndex > 0 ? this.activeIndex - 1 : this.products.length - 1
        );
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        if (this.activeIndex >= 0) {
          this.selectProduct(this.activeIndex);
        }
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        this.closeResults();
      }
    }

    onSubmit(event) {
      event.preventDefault();

      if (this.activeIndex >= 0 && this.products[this.activeIndex]) {
        this.selectProduct(this.activeIndex);
      }
    }

    onReset() {
      window.setTimeout(() => {
        this.resetSearchState();
      }, 0);
    }

    onDocumentClick(event) {
      if (!this.wrapper.contains(event.target)) {
        this.closeResults();
      }
    }

    isOpen() {
      return this.resultsContainer.getAttribute("data-state") === "open";
    }

    openResults() {
      this.resultsContainer.hidden = false;
      this.resultsContainer.setAttribute("data-state", "open");
      this.input.setAttribute("aria-expanded", "true");
    }

    closeResults() {
      this.resultsContainer.hidden = true;
      this.resultsContainer.removeAttribute("data-state");
      this.input.setAttribute("aria-expanded", "false");
      this.input.removeAttribute("aria-activedescendant");
    }

    setStatusText(text) {
      if (!this.statusElement) return;
      this.statusElement.setAttribute("aria-hidden", "false");
      this.statusElement.textContent = text;
      window.setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1000);
    }

    setActiveIndex(index) {
      this.activeIndex = index;

      Array.from(
        this.resultsContainer.querySelectorAll(".ff-search-results__button")
      ).forEach((button, buttonIndex) => {
        const isActive = buttonIndex === index;
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        if (isActive) {
          this.input.setAttribute("aria-activedescendant", button.id);
          button.scrollIntoView({ block: "nearest" });
        }
      });
    }

    renderIdleState() {
      this.resultsContainer.innerHTML = "";
      this.closeResults();
    }

    renderLoadingState() {
      this.resultsContainer.innerHTML = `
        <div class="ff-search-results__loading" role="status" aria-live="polite">
          <div class="ff-search-results__spinner" aria-hidden="true"></div>
          <span class="ff-search-results__status">Searching...</span>
        </div>`;
      this.openResults();
      this.setStatusText("Searching");
    }

    renderErrorState() {
      this.resultsContainer.innerHTML =
        '<div class="ff-search-results__status">Unable to load frame results.</div>';
      this.openResults();
      this.setStatusText("Unable to load frame results");
    }

    renderResults(products, query) {
      this.products = products;
      this.lastQuery = query;
      this.activeIndex = -1;

      if (!products.length) {
        this.resultsContainer.innerHTML = renderNoMatchEmptyState();
        this.openResults();
        this.setStatusText(settings.noResultsText);
        dispatchFrameFinderEvent(this.input, "framefinder:results", {
          query,
          mode: this.mode,
          brand: resolveBrand(this.wrapper, this.input),
          products: [],
        });
        return;
      }

      const items = products
        .map((product, index) => {
          const title = product.frame || product.title || "";
          const buttonId = `${this.input.id || "frame-finder-search"}-option-${index + 1}`;
          let innerHtml;

          if (this.mode === "rare") {
            const matchedCode = findMatchedModelNumber(product, query);
            const codeHtml = matchedCode
              ? `<span class="ff-search-results__model">model number: ${highlightText(
                  matchedCode,
                  query,
                  1
                )}</span>`
              : "";
            innerHtml = `<span class="ff-search-results__title">${escapeHtml(
              title
            )}</span>${codeHtml}`;
          } else {
            innerHtml = highlightText(title, query);
          }

          return `
            <li class="ff-search-results__item" role="presentation">
              <button
                id="${buttonId}"
                type="button"
                class="ff-search-results__button predictive-search__item"
                role="option"
                aria-selected="false"
                data-frame-finder-index="${index}"
              >
                ${innerHtml}
              </button>
            </li>
          `;
        })
        .join("");

      this.resultsContainer.innerHTML =
        `<ul class="ff-search-results__list" role="presentation">${items}</ul>`;
      this.openResults();
      this.setStatusText(`${products.length} results found`);
      dispatchFrameFinderEvent(this.input, "framefinder:results", {
        query,
        mode: this.mode,
        brand: resolveBrand(this.wrapper, this.input),
        products,
      });
    }

    selectProduct(index) {
      const product = this.products[index];
      if (!product) return;

      const displayValue = product.frame || product.title || "";
      const matchedModelNumber =
        this.mode === "rare"
          ? findMatchedModelNumber(product, this.lastQuery)
          : "";

      this.selectedProduct = product;
      this.input.value = displayValue;
      this.input.dataset.selectedProductId = product.id || "";
      this.input.dataset.selectedProductHandle = product.handle || "";
      if (matchedModelNumber) {
        this.input.dataset.selectedModelNumber = matchedModelNumber;
      } else {
        delete this.input.dataset.selectedModelNumber;
      }
      this.closeResults();

      if (this.resetButton) {
        this.resetButton.classList.toggle("hidden", !this.input.value);
      }

      dispatchFrameFinderEvent(this.input, "framefinder:select", {
        product,
        displayValue,
        matchedModelNumber,
        mode: this.mode,
        brand: resolveBrand(this.wrapper, this.input),
      });
    }

    async search(query) {
      const rawBrand = resolveBrand(this.wrapper, this.input);
      const brand = isPlaceholderBrand(rawBrand) ? "" : rawBrand;
      const cacheKey = `${brand.toLowerCase()}::${query.toLowerCase()}`;

      if (this.cache.has(cacheKey)) {
        if (this.input.value.trim() !== query) {
          return;
        }
        this.renderResults(this.cache.get(cacheKey), query);
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }

      this.searchRequestId += 1;
      const requestId = this.searchRequestId;

      this.abortController = new AbortController();
      this.renderLoadingState();

      const url = new URL(`${this.apiBase}/api/frame-finder/search`);
      url.searchParams.set("q", query);
      url.searchParams.set("limit", String(settings.limit));

      if (brand) {
        url.searchParams.set("brand", brand);
      }

      try {
        const response = await fetch(url.toString(), {
          signal: this.abortController.signal,
          headers: {
            Accept: "application/json",
          },
        });

        if (requestId !== this.searchRequestId) {
          return;
        }

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        const products = Array.isArray(data?.products) ? data.products : [];

        if (requestId !== this.searchRequestId) {
          return;
        }

        if (this.input.value.trim() !== query) {
          return;
        }

        this.cache.set(cacheKey, products);
        this.renderResults(products, query);
      } catch (error) {
        if (isAbortError(error)) {
          return;
        }

        if (requestId !== this.searchRequestId) {
          return;
        }

        if (this.input.value.trim() !== query) {
          return;
        }

        console.error("Frame finder search request failed:", error);
        this.renderErrorState();
        dispatchFrameFinderEvent(this.input, "framefinder:error", {
          query,
          brand,
          error,
        });
      }
    }
  }

  function bindFrameFinderSearch() {
    injectStyles();

    const wrappers = getCandidateWrappers();
    wrappers.forEach((wrapper) => {
      if (instances.has(wrapper)) return;
      const instance = new FrameFinderSearch(wrapper);
      if (instance.input && instance.form && instance.resultsContainer) {
        instances.set(wrapper, instance);
      }
    });
  }

  function initialize() {
    bindFrameFinderSearch();

    let debounceTimer = null;

    const observer = new MutationObserver(() => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(bindFrameFinderSearch, 200);
    });

    const observationTarget =
      document.querySelector("frame-finder-drawer") || document.body;

    observer.observe(observationTarget, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
